import { Component } from '@angular/core';

@Component({
  selector: 'lib-web-shared-ui-product-none-tire-card',
  standalone: true,
  imports: [],
  templateUrl: './lib-product-none-tire-card.component.html',
  styleUrl: './lib-product-none-tire-card.component.scss',
})
export class LibProductNoneTireCardComponent {}
